import {
  faFilter,
  faPlus,
  faTags,
  faTimes
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Button from 'components/base/Button';
import SearchBox from 'components/common/SearchBox';
import CompanyFilter from 'components/common/CompanyFilter';
import { useState, ChangeEvent, useMemo, useEffect } from 'react';
import { Col, Row } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import CategoryModal from 'components/modals/CategoryModal';
import CategoryTable from 'components/devices/CategoryTable';
import { fetchCompanies } from 'store/companySlice';
import { AppDispatch, RootState } from 'store';

const Categories = () => {
  const dispatch = useDispatch<AppDispatch>();
  const auth = useSelector((state: RootState) => state.auth);
  const { data: companies } = useSelector(
    (state: RootState) => state.companies
  );

  const [openFilterModal, setOpenFilterModal] = useState(false);
  const [openCreateModal, setOpenCreateModal] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedCompanyId, setSelectedCompanyId] = useState<number | null>(
    null
  );
  const [showFilterPanel, setShowFilterPanel] = useState(false);

  const isSuperAdmin = useMemo(() => auth.role === 'super_user', [auth.role]);

  useEffect(() => {
    if (isSuperAdmin) {
      dispatch(fetchCompanies());
    }
  }, [dispatch, isSuperAdmin]);

  const handleSearchInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(e.target.value);
  };

  const handleCompanySelect = (companyId: number | null) => {
    setSelectedCompanyId(companyId);
  };

  return (
    <div>
      <div className="mb-6">
        <h2
          className="mb-0"
          style={{
            fontSize: '1.5rem',
            fontWeight: '600',
            color: '#374151',
            letterSpacing: '-0.025em'
          }}
        >
          <FontAwesomeIcon icon={faTags} className="me-2 text-primary" />
          Categories
        </h2>
        <Row className="g-3 justify-content-end mb-0">
          <Col xs="auto">
            <div className="d-flex gap-2">
              <button
                className="btn d-flex align-items-center gap-2"
                style={{
                  backgroundColor: 'white',
                  border: '1px solid #e5e7eb',
                  borderRadius: '0.375rem',
                  padding: '0.375rem 0.75rem',
                  fontSize: '0.875rem',
                  color: '#374151',
                  fontWeight: '400'
                }}
                onClick={() => setShowFilterPanel(!showFilterPanel)}
              >
                <FontAwesomeIcon
                  icon={faFilter}
                  style={{ fontSize: '0.875rem' }}
                />
                <span>Filter</span>
              </button>
              <SearchBox
                placeholder="Search by category name"
                value={searchQuery}
                onChange={handleSearchInputChange}
              />
              <Button
                variant="primary"
                startIcon={<FontAwesomeIcon icon={faPlus} />}
                onClick={() => setOpenCreateModal(true)}
                style={{
                  fontSize: '0.875rem',
                  padding: '0.375rem 0.75rem',
                  fontWeight: '500'
                }}
              >
                Add Category
              </Button>
            </div>
          </Col>
        </Row>

        {/* Filter Panel */}
        {showFilterPanel && isSuperAdmin && (
          <div className="mb-3 mt-3">
            <div className="d-flex gap-2">
              <CompanyFilter
                companies={companies}
                selectedCompanyId={selectedCompanyId}
                onCompanySelect={handleCompanySelect}
              />
            </div>
          </div>
        )}

        {/* Category Table */}
        <div className="mt-3">
          <CategoryTable
            searchQuery={searchQuery}
            selectedCompanyId={selectedCompanyId}
          />
        </div>

        {/* Category Modal */}
        <CategoryModal
          show={openCreateModal}
          handleClose={() => setOpenCreateModal(false)}
        />
      </div>
    </div>
  );
};

export default Categories;
